import { vevet } from '@anton.bobrov/vevet-init';
import { isNumber } from '@anton.bobrov/react-hooks';
export function getVerticalAlignmentStyles(_a) {
    var domRect = _a.domRect, alignment = _a.alignment, gapProp = _a.gap;
    if (!domRect) {
        return undefined;
    }
    var gap = isNumber(gapProp) ? gapProp : gapProp();
    if (alignment === 'down') {
        return {
            top: "".concat(domRect.bottom + gap, "px"),
            bottom: 'auto',
            y: '0',
        };
    }
    if (alignment === 'up') {
        return {
            top: 'auto',
            bottom: "".concat(vevet.viewport.height - domRect.top + gap, "px"),
            y: '0',
        };
    }
    if (alignment === 'center') {
        return {
            top: "".concat(domRect.top + domRect.height / 2, "px"),
            bottom: 'auto',
            y: '-50%',
        };
    }
    return undefined;
}
//# sourceMappingURL=getVerticalAlignmentStyles.js.map